import { createActionThunk } from 'redux-thunk-actions'
import { actions as toastr } from 'react-redux-toastr'
import { push } from 'react-router-redux'
import { I18n } from 'react-redux-i18n'

import api from 'core/api'
import { getAbilities } from 'modules/infos/abilities'
import { reset } from 'modules/calculations/estimates'
import { destroySessionProlongation } from 'modules/users/sessions/prolong'

export const signOutThunk = createActionThunk(
  'SIGN_OUT',
  api('/users/sessions', { method: 'DELETE' })
)

export const signOut = props => dispatch =>
  dispatch(signOutThunk(props))
    .then(() => {
      dispatch(push('/'))
      dispatch(toastr.add({ type: 'success', message: I18n.t('devise.sessions.signed_out') }))
      dispatch(getAbilities())
      dispatch(reset())
      dispatch(destroySessionProlongation())
    })
    .catch(res => {
      dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
      dispatch(getAbilities())
      dispatch(reset())
      dispatch(destroySessionProlongation())
    })



// WEBPACK FOOTER //
// ./src/modules/users/sign_out.js